import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ITableColumn, TableList } from "src/components/table";
import CardActions from "src/pages/sistema/components/CardActions";
import { ICON_MAS } from "src/pages/sistema/components/SharedIcons";
import DeleteIcon from '@mui/icons-material/Delete';
import { Control, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { AsyncSelect, ControlledTextField } from "src/components/forms";
import { HttpWRC } from "../api";
import { EntityWithIdAndDescriptionFields, EntityWithIdFields } from "src/types";
import { DetalleProvisional, DetalleProvisionalFields, detalleProvisional } from "../NuevoSistemaWRCredito";
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog";
import { v4 as uuid } from 'uuid'


const AsyncLabel = ({ idPais, codOperacionTipo }: { idPais: number, codOperacionTipo: number }) => {

    const [label, setLabel] = useState<string>()

    useEffect(() => {
        HttpWRC.getTipos(idPais)
            .then(tipos => {
                const l = tipos.find(tipo =>
                    tipo[EntityWithIdFields.Id] === codOperacionTipo
                )?.[EntityWithIdAndDescriptionFields.Description]

                setLabel(l)
            })
    }, [codOperacionTipo, idPais])

    return !label ? <></> : <Typography>{label}</Typography>
}

const NuevoDetalleWRCDialog = (
    { control, idPais, setOpenDialog, handleSubmit }:
        { control: Control<DetalleProvisional>, idPais: number, setOpenDialog: Dispatch<SetStateAction<boolean>>, handleSubmit: () => void }) => {

    return (
        <>
            <DialogTitle>Nuevo detalle</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} pt={2}>
                    <Grid item xs={12} md={6}>
                        <AsyncSelect
                            control={control}
                            name={DetalleProvisionalFields.CodOperacionTipo}
                            label='Operación'
                            loadOptions={() => HttpWRC.getTipos(idPais)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ControlledTextField
                            control={control}
                            name={DetalleProvisionalFields.Excepcion}
                            label='Excepción'
                            multiline
                            rows={2}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='text' color='primary' onClick={() => setOpenDialog(false)}>
                    Cancelar
                </Button>
                <Button variant='contained' color='primary' onClick={
                    handleSubmit
                }
                >
                    Agregar
                </Button>
            </DialogActions>
        </>
    )
}

const SeccionWRCDetalleNuevo = (
    {
        idPais,
        detallesProvisionales,
        setDetallesProvisionales
    }: {
        idPais: number,
        detallesProvisionales: DetalleProvisional[],
        setDetallesProvisionales: Dispatch<SetStateAction<DetalleProvisional[]>>
    }) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    // const {status, detalles, refetch} = useDetalles(idOperacion)

    const { askConfirmation } = useConfirmationDialog();

    const columnsTablaWRMInstrumento: ITableColumn[] = [
        {
            label: 'Operación',
            onRenderCell: (entity: DetalleProvisional) => (
                <AsyncLabel idPais={idPais} codOperacionTipo={entity[DetalleProvisionalFields.CodOperacionTipo]} />
            )
        },
        { label: 'Excepción', value: DetalleProvisionalFields.Excepcion },
        {
            label: 'Acciones', onRenderCell: (entity: DetalleProvisional) => (
                <Tooltip title='Eliminar'>
                    <IconButton
                        onClick={
                            () => askConfirmation(
                                () => setDetallesProvisionales(
                                    dts => dts.filter(dt => dt.idProvisional !== entity.idProvisional)
                                )
                            )
                        }
                    >
                        <DeleteIcon color='error' />
                    </IconButton>
                </Tooltip>
            ),
            width: 0.1
        }
    ]

    const { control, handleSubmit, reset } = useForm<DetalleProvisional>({
        resolver: zodResolver(detalleProvisional),
        defaultValues: {
            idProvisional: uuid(),
        }
    });

    const alGuardarDetalleProvisional = (data: DetalleProvisional) => {
        const nuevoDetalle: DetalleProvisional = {
            idProvisional: uuid(),
            codOperacionTipo: data[DetalleProvisionalFields.CodOperacionTipo],
            operacionExcepcion: data[DetalleProvisionalFields.Excepcion]
        }
        setDetallesProvisionales(prev => [...prev, nuevoDetalle])
        reset()
        setOpenDialog(false)
    }

    // TODO: el content del dialog debería ir a otro component, no su contenido
    return (
        <CardActions
            title={"Operación MinutaCredito Cuentas"}
            actions={
                <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                    Nuevo
                </Button>
            }
            colapsable
            tableContent
        >
            <TableList
                entityList={detallesProvisionales}
                columns={columnsTablaWRMInstrumento}
                isLoading={false}
                error={false}
            />
            {
                openDialog &&
                <Dialog open={openDialog} maxWidth='sm' fullWidth>
                    <NuevoDetalleWRCDialog
                        control={control}
                        setOpenDialog={setOpenDialog}
                        idPais={idPais}
                        handleSubmit={handleSubmit(alGuardarDetalleProvisional)}
                    />
                </Dialog>
            }

        </CardActions>
    )
}

export default SeccionWRCDetalleNuevo;
